<template>
  <section :class="['game-description', gameName, region]" :style="cardStyle">
    <div :class="['content-wrapper', gameName]">
      <img v-if="gameIcon" class="icon" v-lazy="gameIcon" alt="icon" />
      <p class="title" :style="titleColor">
        {{ text.displayName }}
      </p>
      <div
        class="drop-down"
        :style="{ transform: `rotate(${rotateDeg}deg)` }"
        @click="toggleExpand"
      >
        <MBIcon
          name="icon-black-arrow"
          :size="40"
          :opacity="0.5"
          :color="titleColor.color"
        />
      </div>
    </div>
    <div class="expand-content-wrapper" v-show="showHiddenContent">
      <p class="subtitle" :style="titleColor" v-html="text.game_desc"></p>
      <div class="download-app-section flex-start" v-show="gameName === 'hago'">
        <button
          v-for="data in appStoreInfo"
          :key="data.id"
          class="flex-start"
          @click="goDownload(data.id)"
        >
          <img v-lazy="data.imgSrc" :alt="data.logoName" />
          <div>
            <p>{{ data.guideText }}</p>
            <p class="logo-name">{{ data.logoName }}</p>
          </div>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
  import MBIcon from '@/components/MBIcon'
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  import { mapState } from 'vuex'
  import { gameDownloadClick } from '@/pages/Detail/firebase.js'

  export default {
    mixins: [styleConfiguration],
    components: {
      MBIcon,
    },
    props: {
      text: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        showHiddenContent: false,
        rotateDeg: 0, // 默认收起内容，箭头朝下
        appStoreInfo: [
          {
            id: 'Apple',
            imgSrc: require(`@/assets/images/common/app-store-logo/AppleStore.png`),
            logoName: 'App Store',
            guideText: 'Download on the',
          },
          {
            id: 'Google',
            imgSrc: require(`@/assets/images/common/app-store-logo/GooglePlay.png`),
            logoName: 'Google Play',
            guideText: 'GET IT ON',
          },
          {
            id: 'GetApps',
            imgSrc: require(`@/assets/images/common/app-store-logo/GetApps.png`),
            logoName: 'GetApps',
            guideText: 'GET IT ON',
          },
        ],
      }
    },
    computed: {
      ...mapState(['region', 'gameName', 'isXiaomiDevice']),

      titleColor() {
        return this.mFontColor
      },
      cardStyle() {
        return this.moduleBackColor
      },
    },
    methods: {
      toggleExpand() {
        this.showHiddenContent = !this.showHiddenContent
        this.rotateDeg = this.rotateDeg === 180 ? 0 : 180 // 角度翻转
      },
      goDownload(id) {
        gameDownloadClick(this.gameName, id)
        if (id === 'Apple' || id === 'Google') {
          window.location = 'https://playhago.onelink.me/5EpX/f8p690qs'
        } else if (id === 'GetApps') {
          window.location = 'mimarket://details?id=com.yy.hiyo'
        }
      },
    },
  }
</script>
<style scoped lang="scss" src="./index.scss"></style>
